import httpRequest from '@/utils/request';

const moduleUrl = '/Module';

export const loadModuleTemplates = (): Promise<IModule.IResponse.IModuleTemplateData> => {
  return httpRequest.get(`${moduleUrl}/getModuleTemplates`);
};
export const saveModuleTemplate = (
  templateData: IModule.IRequest.IModuleTemplateParams,
): Promise<IResponseData.IBaseData> => {
  return httpRequest.post(`${moduleUrl}/setModuleTemplate`, templateData);
};
export const deleteModuleTemplate = (templateId: string): Promise<IResponseData.IBaseData> => {
  return httpRequest.delete(`${moduleUrl}/${templateId}/delete`);
};
export const cancelModuleTemplate = (id: string): Promise<IResponseData.IBaseData> => {
  return httpRequest.patch(`${moduleUrl}/${id}/cancel`);
};
